import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Highlight from './components/Highlight';
import ContactForm from './components/ContactForm';
import Map from './components/Map';
import Footer from './components/Footer';
import './styles/App.css';
import GallerySection from './components/GallerySection';
import ParallaxTextSection from './components/ParallaxTextSection';
import FloatingEmailButton from './components/FloatingEmailButton';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Highlight />
        <GallerySection />
        <ParallaxTextSection />
        <ContactForm />
        <Map />
        <FloatingEmailButton />
      </main>
      <Footer />
    </>
  );
}

export default App;